import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { ConsumablesFormStepSection } from "@jti/ui/components/ConsumablesFormStepSection";
import { MultipleFlavorsSelector } from "@jti/ui/components/MultipleFlavorsSelector";
import { SingleFlavorSelector } from "@jti/ui/components/SingleFlavorSelector";
import { useConfig } from "@jti/ui/providers/useConfig";
import { useConsumablesProductDetailsContext } from "../../../../providers/ConsumablesProductDetailsProvider";
import { getMixedConsumableFlavors } from "../../../../utils/getMixedConsumableFlavors";
import { getSingleFlavorConsumable } from "../../../../utils/getSingleFlavorConsumable";
import { useConsumablesStockStatuses } from "../../hooks/useConsumablesStockStatuses";
import { ConsumablesSectionTitle } from "../ConsumablesFormSectionTitle";
import styles from "./ConsumablesFlavorSelectorSection.module.scss";
export const ConsumablesFlavorSelectorSection = ({ step, contentsType, purchaseType, onFlavorChangeSubmit, shouldValidate = false, }) => {
    const { displayOutOfStockStickProducts } = useConfig();
    const { consumablesProductDetailsComponentData, currentMatrixItem } = useConsumablesProductDetailsContext();
    const stockStatusesQueryState = useConsumablesStockStatuses();
    const { items: consumablesMatrixItems } = consumablesProductDetailsComponentData.consumablesMatrixData;
    const elementsStockStatus = stockStatusesQueryState.data ?? {};
    const singleFlavorItems = useMemo(() => {
        if (contentsType === "mixed") {
            return [];
        }
        const items = consumablesMatrixItems.filter((item) => {
            return (item.sku !== currentMatrixItem.sku &&
                item.packagingFormatId === currentMatrixItem.packagingFormatId &&
                item.purchaseType === purchaseType);
        });
        return items.map(getSingleFlavorConsumable);
    }, [consumablesMatrixItems, currentMatrixItem, contentsType]);
    const singleFlavorInitialSelection = useMemo(() => {
        if (contentsType === "mixed" || !currentMatrixItem) {
            return null;
        }
        return getSingleFlavorConsumable(currentMatrixItem);
    }, [currentMatrixItem, contentsType]);
    const selectedBundleConfig = currentMatrixItem?.product.productBundleConfiguration?.items?.[0];
    const getMixedConsumablesFlavorOptions = () => {
        if (contentsType !== "mixed" || !selectedBundleConfig?.allOptions) {
            return [];
        }
        const mixedFlavorBundleItems = selectedBundleConfig.allOptions.map(getMixedConsumableFlavors);
        if (!displayOutOfStockStickProducts) {
            return mixedFlavorBundleItems.filter((flavor) => {
                if (!Object.hasOwn(elementsStockStatus, flavor.id))
                    return false;
                return elementsStockStatus[flavor.id] === "IN_STOCK";
            });
        }
        return mixedFlavorBundleItems;
    };
    const onSelectedFlavourChange = (sku) => {
        onFlavorChangeSubmit({ sku });
    };
    const setSelectedFlavors = (flavorsSelection) => {
        onFlavorChangeSubmit({ flavorsSelection });
    };
    return (_jsxs(ConsumablesFormStepSection, { title: _jsx(ConsumablesSectionTitle, { translationKey: "consumablesForm.section.flavor_selector_section.title", stepCount: step }), "data-testid": "consumables-flavor-selector", children: [contentsType === "mixed" && (_jsx(MultipleFlavorsSelector, { limit: selectedBundleConfig?.qty ?? 0, items: getMixedConsumablesFlavorOptions(), stockStatusElements: elementsStockStatus, onChange: setSelectedFlavors, isProductDataLoading: stockStatusesQueryState.isLoading, shouldValidate: shouldValidate, className: styles.flavorSelector }, currentMatrixItem.sku)), contentsType !== "mixed" && singleFlavorInitialSelection && (_jsx(SingleFlavorSelector, { flavors: singleFlavorItems, initialSelection: singleFlavorInitialSelection, stockStatusElements: elementsStockStatus, isProductDataLoading: stockStatusesQueryState.isLoading, onChange: onSelectedFlavourChange, className: styles.flavorSelector }, currentMatrixItem.sku))] }));
};
//# sourceMappingURL=ConsumablesFlavorSelectorSection.js.map